<template>
  <div
    class="custom-box-shadow flex h-full w-auto flex-col rounded border border-steel-200 p-4"
  >
    <div class="flex flex-row justify-between">
      <h1 class="text-neutral-1100 text-lg font-medium">
        {{ nullTextify(insurance.insurance_type) }}
      </h1>
      <div
        class="flex h-6 items-center justify-center gap-1 rounded-full bg-forest-500 px-2 py-0.5 text-white"
      >
        <span class="whitespace-nowrap text-sm font-medium">Active</span>
      </div>
    </div>
    <div class="flex flex-col">
      <span class="text-xs font-medium text-steel-800">Insurer Name</span>
      <p class="text-neutral-1100 text-xs font-medium">
        {{ formatTitleCase(insurance.insurer_name) }}
      </p>
    </div>
    <span class="my-2 border-b border-steel-200"></span>

    <div class="flex flex-col gap-6">
      <div class="align-items flex justify-between">
        <div class="flex w-[200px] flex-col gap-0.5">
          <span class="text-xs font-medium text-steel-800">Policy Number</span>
          <span class="text-neutral-1100 text-xs font-medium">
            {{ formatPolicy(insurance.policy_number) }}
          </span>
        </div>
        <span class="mx-4 my-1 border-l border-steel-200"></span>
        <div class="flex w-full flex-col gap-0.5">
          <span class="text-xs font-medium text-steel-800">Coverage</span>
          <span class="text-neutral-1100 text-xs font-medium">
            ${{ nullTextify(coverageInThousands.toLocaleString()) }}
          </span>
        </div>
      </div>
    </div>
    <span class="my-2 border-b border-steel-200"></span>

    <div class="flex flex-col gap-6">
      <div class="align-items flex justify-between">
        <div class="flex w-[200px] flex-col gap-0.5">
          <span class="text-xs font-medium text-steel-800">Effective Date</span>
          <span class="text-neutral-1100 text-xs font-medium">
            {{ nullTextify(displayDate(insurance.effective_date)) }}
          </span>
        </div>
        <span class="mx-4 my-1 border-l border-steel-200"></span>
        <div class="flex w-full flex-col gap-0.5">
          <span class="text-xs font-medium text-steel-800">
            Cancellation Date
          </span>
          <span class="text-neutral-1100 text-xs font-medium">
            {{ nullTextify(displayDate(insurance.cancellation_date)) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'InsuranceGovernmentCard',
  props: {
    insurance: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coverageInThousands() {
      return this.insurance.coverage * 1000;
    },
  },
  methods: {
    formatTitleCase(string) {
      const normalizedString = this.nullTextify(string);
      if (normalizedString === 'N/A') return 'N/A';

      return normalizedString
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    displayDate: function (initialDate) {
      if (initialDate == null) {
        return initialDate;
      } else {
        return moment(initialDate, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    nullTextify: function (value, nullVal = 'N/A') {
      if (value == null) {
        return nullVal;
      } else {
        return value;
      }
    },
    formatPolicy(number) {
      const policy = this.nullTextify(number);

      if (policy?.length > 30) {
        return `${policy.slice(0, 28)}...`;
      }

      return policy;
    },
  },
};
</script>
<style></style>
